import { c as _c } from "react/compiler-runtime";
import { useRequestErrorToast } from '@onefootprint/hooks';
import type { EditPlaybookHistory } from '@onefootprint/request-types/dashboard';
import { motion } from 'framer-motion';
import { panelWidthOf, useNodePanel } from '@/components/playbook-builder/components/node-panel/node-panel-context';
import { HistoryButton } from './history-button';
import { undoNudgePx } from './undo-nudge';
const CONTROL_WIDTH = 96;
type GraphUndoRedoProps = {
  history: EditPlaybookHistory;
  onRestore: (logId: string) => Promise<void>;
  isPending: boolean;
};
export const GraphUndoRedo = t0 => {
  const $ = _c(24);
  const {
    history,
    onRestore,
    isPending
  } = t0;
  const showRequestErrorToast = useRequestErrorToast();
  const {
    descriptor
  } = useNodePanel();
  let t1;
  if ($[0] !== descriptor) {
    t1 = typeof window === "undefined" ? 0 : undoNudgePx({
      viewportWidth: window.innerWidth,
      controlWidth: CONTROL_WIDTH,
      panelWidth: panelWidthOf(descriptor)
    });
    $[0] = descriptor;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const nudge = t1;
  let t2;
  if ($[2] !== onRestore || $[3] !== showRequestErrorToast) {
    t2 = async logId => {
      if (!logId) {
        throw Error("No log ID to which to restore");
      }
      ;
      try {
        await onRestore(logId);
      } catch (t3) {
        const error = t3;
        showRequestErrorToast(error);
      }
    };
    $[2] = onRestore;
    $[3] = showRequestErrorToast;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const handleRestore = t2;
  if (!history?.previous && !history?.next) {
    return null;
  }
  let t3;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      opacity: 0,
      y: 100
    };
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const t4 = -nudge;
  let t5;
  if ($[6] !== t4) {
    t5 = {
      opacity: 1,
      y: -16,
      x: t4
    };
    $[6] = t4;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  let t7;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = {
      opacity: 0,
      y: 100
    };
    t7 = {
      duration: 0.3
    };
    $[8] = t6;
    $[9] = t7;
  } else {
    t6 = $[8];
    t7 = $[9];
  }
  let t8;
  if ($[10] !== handleRestore || $[11] !== history.previous || $[12] !== isPending) {
    t8 = <HistoryButton kind="undo" item={history.previous} isPending={isPending} onClick={handleRestore} />;
    $[10] = handleRestore;
    $[11] = history.previous;
    $[12] = isPending;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  let t9;
  if ($[14] !== handleRestore || $[15] !== history.next || $[16] !== isPending) {
    t9 = <HistoryButton kind="redo" item={history.next} isPending={isPending} onClick={handleRestore} />;
    $[14] = handleRestore;
    $[15] = history.next;
    $[16] = isPending;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  let t10;
  if ($[18] !== t8 || $[19] !== t9) {
    t10 = <footer className="flex items-center justify-between m-auto p-2 border rounded-full shadow-md border-tertiary bg-primary"><div className="flex items-center gap-3 flex-row">{t8}{t9}</div></footer>;
    $[18] = t8;
    $[19] = t9;
    $[20] = t10;
  } else {
    t10 = $[20];
  }
  let t11;
  if ($[21] !== t10 || $[22] !== t5) {
    t11 = <motion.div className="fixed left-0 right-0 bottom-0 max-md:bottom-[env(safe-area-inset-bottom)] mx-auto w-[96px] z-10" initial={t3} animate={t5} exit={t6} transition={t7}>{t10}</motion.div>;
    $[21] = t10;
    $[22] = t5;
    $[23] = t11;
  } else {
    t11 = $[23];
  }
  return t11;
};